<template>
  <div class="relative">
    <button
      type="button"
      ref="button"
      class="relative ml:w-[8.5rem] w-16 h-9 cursor-pointer rounded-lg border-[0.74px] border-gray-300 bg-white py-1.5 ml:px-3 px-2 pl-1 ltr:pr-0 rtl:pl-0 ltr:text-left rtl:text-right text-gray-900 shadow-ts1 sm:text-sm sm:leading-6 ml:flex block items-center justify-between"
      @click="displayHide? hidePopover() : showPopover()"
    >
      <span class="flex items-center gap-1 ml:gap-2 ">
        <img :src="getLanguageInfo.flag" :alt="getLanguageInfo.name" class="ml:w-6 ml:h-6 w-4 h-4  rounded-full" />
        <span class="text-base text-gray-900">{{ getLanguageInfo.displayName }}</span>
        <svg class="ml:w-3 ml:h-2 w-2 h-1.5 stroke-current text-gray-900 transform" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 8" :class="displayHide ? 'rotate-180' : 'rotate-0'">
        <path d="M0.5,0.774l6.499,6.452l6.5-6.452" fill="none" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      </span>

    </button>

    <!-- Dropdown list -->
    <ul
      v-closable="{ exclude: ['button'], handler: 'hidePopover', isOpen: displayHide }"
      v-show="displayHide"
      class="absolute z-[2] mt-2 max-h-56 w-full overflow-auto rounded-lg bg-white py-1 text-base shadow-ts1 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
    >
      <li
        v-for="language in getOtherLanguages"
        :key="language.name"
        class="relative cursor-default select-none py-2  ltr:pl-2 rtl:pr-2 text-gray-900"
        @click="setLanguage(language)"
      >
        <div class="flex items-center ltr:ml:gap-3 rtl:ml:gap-5 gap-1.5">
          <img :src="language.flag" :alt="language.name" class="ml:w-6 ml:h-6 w-4 h-4 rounded-full" />
          <span class="block truncate font-normal hover:text-blue-500 hover:cursor-pointer"> {{ language.displayName }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const languageMap = {
  en: { name: 'English', shortName: 'En', flag: '/static/img/uk.svg' },
  es: { name: 'Spanish', shortName: 'Es', flag: '/static/img/spain.svg' },
  fa: { name: 'Farsi', shortName: 'Fa', flag: '/static/img/fa.svg' },
}

export default {
  name: 'LanguageMarketing',
  data() {
    return {
      displayHide: false,
      selectedLanguageCode: null,
      isMobile: window.innerWidth < 434,
    }
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
    dropDownIcon() {
      return this.displayHide ? require('../assets/img/icons/newsfeed/arrow.svg') : require('../assets/img/platform-dropdown.svg')
    },
    getLanguageInfo() {
      const language = languageMap[this.selectedLanguageCode]
      return {
        ...language,
        displayName: this.isMobile ? language.shortName : language.name,
      }
    },
    getOtherLanguages() {
      return Object.keys(languageMap)
        .filter(code => code !== this.selectedLanguageCode)
        .map(code => {
          const language = languageMap[code]
          return {
            ...language,
            displayName: this.isMobile ? language.shortName : language.name,
          }
        })
    },
  },
  /**
   * Use created instead of mounted: It runs earlier and is more efficient for emitting events or initializing state.
   * Since we don't need access to the DOM, created is the better choice here.
   */
  created() {
    this.selectedLanguageCode = this.Language // Initialize selected language code
    this.$emit('language-selected', this.selectedLanguageCode) // Emit the selected language code when the component is created
  },
  mounted() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateIsMobile)
  },
  watch: {
    Language(val) {
      this.selectedLanguageCode = val
    },
  },

  methods: {
    showPopover() {
      this.displayHide = true
    },
    hidePopover(){
      this.displayHide = false
    },
    setLanguage(language) {
      const code = Object.keys(languageMap).find(key => languageMap[key].name === language.name)
      this.selectedLanguageCode = code // Update selected language code
      this.$emit('language-selected', code) // Emit the selected language code to the parent
      this.displayHide = false // Hide dropdown after selection
    },
    updateIsMobile() {
      this.isMobile = window.innerWidth < 434
    },
  },
}
</script>
